module.exports = __webpack_public_path__ + "img/libro_reclamaciones_white.716f8de7.png";